var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "one section"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "3em",
      "padding-bottom": "3em"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('article', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('h1', {
    staticClass: "subtitle is-2 hide-mobile"
  }, [_vm._v("\n              Automate condo association insurance certificate requests\n            ")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle is-3 hide-desktop"
  }, [_vm._v("\n              Automate condo association insurance certificate requests\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We provide a simple, cost effective solution to remove the burden of condo association evidence of insurance requests from\n              banks and property owners.\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n              Contact us now for a free, no obligation trial and assistance getting started.\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button is-success is-large",
    on: {
      "click": function($event) {
        _vm.showContactForm = true
      }
    }
  }, [_vm._v("Contact Us")])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "section two"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n            Manage your associations, policies and coverage details\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Once you set up an association, you will get a direct link for requesters to access the applicable evidence of insurance\n            certificate. Decide on privacy controls and distribute the link to anyone who needs access to the certificate to streamline the process and\n            provide better service to your associations.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            For more information, read our\n            "), _c('router-link', {
    staticClass: "has-text-info",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("Getting Started")]), _vm._v(" page.\n          ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n            Simple monthly pricing\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Unlimited associations and requests for a flat monthly price.\n            "), _c('a', {
    staticClass: "has-text-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContactForm = true
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(" for a special introductory rate.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n            Try it out\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Try a demo request now and generate a sample EOI certificate.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link",
    attrs: {
      "to": "/certificates/arrowig/ABC123"
    }
  }, [_vm._v("Demo")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "section three"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              Do you need an insurance certificate?\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/certificates"
    }
  }, [_vm._v("Search By Association")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              Broker Login\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              Certificate of Property Insurance Form\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/fillable-certificate-of-property-insurance-form"
    }
  }, [_vm._v("Online Fillable Form")])], 1)])])])]), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showContactForm
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  })]), _vm._v(" "), (!_vm.contactSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter your email address"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter your message, we'll respond as quickly as possible"
    },
    domProps: {
      "value": (_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.sendContactMessage(_vm.contact)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.contactSuccess) ? _c('div', [_vm._m(2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column hide-mobile"
  }, [_c('figure', {
    staticClass: "image",
    staticStyle: {
      "margin-left": "10%",
      "min-height": "330px"
    }
  }, [_c('img', {
    attrs: {
      "id": "cta-image",
      "src": "/static/img/LandingPageCertificateForm.jpg"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column hide-mobile"
  }, [_c('figure', {
    staticClass: "image center-image",
    staticStyle: {
      "min-height": "358px"
    }
  }, [_c('img', {
    attrs: {
      "id": "cta-image",
      "src": "/static/img/LandingPageManageAssociations.jpg"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you for contacting us. We will return your message as soon as possible.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246bbd84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = H1VY
// module chunks = 1